<template>
  <div v-if="data_detail.form">
    <div
      class="modal fade"
      :class="data_detail.modal ? 'show' : ''"
      style="display: block"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width : 800px" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div style="margin-top : 10px">
                <ul>
                    <li>Detail {{ucwords(data_detail.referensi)}}</li>
                    <li>Gudang : {{data_detail.nama_gudang}}</li>
                    <li>Barang : {{data_detail.nama_barang}} ({{data_detail.kode_barang}})</li>
                </ul>
            </div>
            <button
              type="button"
              class="close"
              v-on:click="triggerDetail()"
              v-html="loading ? spin() : ic('close')"
            />
          </div>

          <div class="modal-body pt-3">
              <table class="table">
                  <thead>
                      <th>Id</th>
                      <th>Nomor Detail</th>
                      <th>Nomor Induk</th>
                      <th>Tanggal</th>
                      <th>Referensi</th>
                      <th>Qty</th>
                      <th>Qty Pcs</th>
                      <th>Keterangan</th>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in data_laporan_detail" :key="i">
                      <td>{{row.id}}</td>
                      <td>{{row.id_referensi}}</td>
                      <td>{{row.no_referensi}}</td>
                      <td>{{row.tanggal}}</td>
                      <td>{{row.referensi}}</td>
                      <td>{{row.qty | currency}}</td>
                      <td>{{row.qty_pcs | currency}}</td>
                      <td>{{row.status}}</td>
                    </tr>
                  </tbody>
              </table>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-white"
              v-on:click="triggerDetail()"
              v-html="'Tutup'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import helper from "@/assets/js/helper.js";

export default {
  name: "Modal",
  mixins: [helper],
  computed: {
    ...mapState(["loading"]),
    ...mapState("posisi_stock", {
      data_detail: (state) => state.data_detail,
      data_laporan_detail : (state) => state.data_laporan_detail
    }),
  },
  data() {
    return {
      selectizeConfig: {
        maxItems: 99,
        plugins: ["remove_button"],
      },

      principal: [],
      brand: [],
      barang: [],
    };
  },

  methods: {
    ...mapActions("posisi_stock", ["triggerDetail", "getDetail"]),
  },
  created(){
  },
  mounted: function() {
  },
};
</script>
